import { render } from "./FrisbuyGalleryScrollbar.vue?vue&type=template&id=6ac181c2&scoped=true"
import script from "./FrisbuyGalleryScrollbar.vue?vue&type=script&lang=js"
export * from "./FrisbuyGalleryScrollbar.vue?vue&type=script&lang=js"

import "./FrisbuyGalleryScrollbar.vue?vue&type=style&index=0&id=6ac181c2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac181c2"]])

export default __exports__